import React from 'react';
import { Box, Typography } from '@mui/material';

const AccessDenied = () => {
  return (
    <Box 
      display="flex" 
      flexDirection="column" 
      alignItems="center" 
      justifyContent="center" 
      sx={{ textAlign: 'center' }}
    >
      <Typography variant="h4" sx={{ mb: 2 }}>
        У вас нет прав доступа
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        Пожалуйста, обратитесь к владельцу для получения доступа.
      </Typography>
    </Box>
  );
};

export default AccessDenied;
